import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'brand-vue', 'IconBrandVue', [["path",{"d":"M16.5 4l-4.5 8l-4.5 -8","key":"svg-0"}],["path",{"d":"M3 4l9 16l9 -16","key":"svg-1"}]]);